import { render } from "./employee-edit-model.vue?vue&type=template&id=afd034a0"
import script from "./employee-edit-model.vue?vue&type=script&lang=js"
export * from "./employee-edit-model.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__